var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleSearchConsole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2230,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296 264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 22l22-22v42H83zM213 22L191 0v42h22z",
    fill: "#7b7b7b",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 0h86v21h-86z",
    fill: "#5a5a5a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272 264H24a24 24 0 0 1-24-24V83.238L41.238 42h213.524L296 83.238V240a24 24 0 0 1-24 24z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 127V83.238L41.238 42h213.524L296 83.238V127z",
    fill: "#d0d1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 264V94a10 10 0 0 1 10-10h208a10 10 0 0 1 10 10v170z",
    fill: "#458cf5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 127h228v137H34z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194 264v-41l-20-20-13-36 9-23 51 51 9-38 32 32v75z",
    fill: "#d2d3d4",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 143h76v85H49zM49 247h98v17H49z",
    fill: "#d2d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213 232.1V264h-42v-31.447a49.507 49.507 0 0 1-1-89.651V190l21 13 22-13v-47.1a49.518 49.518 0 0 1 0 89.2z",
    fill: "#505050",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 95a8.5 8.5 0 1 1-8.5 8.5 8.5 8.5 0 0 1 8.5-8.5zm25 0a8.5 8.5 0 1 1-8.5 8.5 8.5 8.5 0 0 1 8.5-8.5z",
    fill: "#e6e7e8",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSearchConsole);
export default __webpack_public_path__ + "static/media/google_search_console.196b662a47ecb28b71737f8af03ecd3e.svg";
export { ForwardRef as ReactComponent };